import Block from './Block.vue'

export default Block
